define([
    'common/ui/view/svg/shape/index',
    'common/ui/view/svg/util'
], function(
    Shape,
    SVGUtil
    ) {
    var RectShape = Shape.extend({
        tagName: 'g',
        initialize: function(params) {
            RectShape.__super__.initialize.call(this, params);
            this.rx = this.params.rx;
            this.ry = this.params.ry;
        },

        offset: function() {
            return {
                x: this._offset.x - this._width / 2,
                y: this._offset.y - this._height / 2
            }
        },

        imageSize: function() {
            return this._width > this._height ? this._width : this._height;
        },

        imageOffset: function() {
            var imageSize = this.imageSize();
            return {
                x: - (imageSize - this._width) / 2,
                y: - (imageSize - this._height) / 2
            };
        },

        onRender: function() {
            this.$el.selectAll('rect').remove();
            var rect = this.$el
                .append('rect')
                .attr('width', this._width)
                .attr('height', this._height)
                .attr('transform', SVGUtil.transform(this.offset()));

            if(this.rx) {
                rect.attr('rx', this.rx);
            }
            if(this.ry) {
                rect.attr('ry', this.ry);
            }
            return this;
        }
    }, {
        type: 'rect'
    });

    return RectShape;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/shape/rect.js